import { IntegrationsType, IUser } from 'kach-clients'

export const buildIntegrationConnectionQueryKey = (
  type: IntegrationsType,
  user: Partial<IUser>,
) => {
  return `integration-connection-${type}-${user?.id}`
}
